import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { parseJwt } from "../components/utilities/utils";
import { BASE_URLS, PLATFORM_TYPE } from "../constants/constants";
let userDetails = localStorage.getItem("access_token")
  ? parseJwt(localStorage.getItem("access_token"))
  : {};

let { authorizedDistricts, authorizedStates, authorizedAcs } = userDetails;
export const objectStoreApi = createApi({
  reducerPath: "objectStoreApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.OBJECTSTORE_BASE_URL,
    prepareHeaders: (headers) => {
      // headers.set("authorization", `Bearer ${localStorage.access_token}`);
      headers.set("currentRole", localStorage.userrole);
      // headers.set("state", authorizedStates[0]);
      headers.set("appName", "ETPBMS");
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      return headers;
    }, 
}),
  endpoints: (builder) => ({
    GetObjectStoreFile: builder.query({
      query: (fileName) => ({
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
           appName:"ETPBMS"
        },
        url: `api/v1/document/getFile?bucketName=objectstorage&fileName=${fileName}`,
        method: "GET",
      }),
    }),

    DeleteObjectStoreFile: builder.query({
      query: (fileName) => ({
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'currentRole':localStorage.userrole,
          appName:"ETPBMS"
        },
        url: `api/v1/document/deleteFile?bucketName=objectstorage&fileName=${fileName}`,
        method: 'DELETE',
      })
    }),
    DownloadObjectStoreFile: builder.query({
      query: (fileName) =>{
         return {
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'currentRole':localStorage.userrole,
          appName:"ETPBMS"
        },
        url: `api/v1/document/downloadFile?bucketName=objectstorage&fileName=${fileName}`,
        method: "GET",
      }},
    }),

    SubmitObjectStoreUpload: builder.mutation({
      headers: {
        "Content-type": "multipart/form-data",
        Accept: "application/json",
        charset: "UTF-8",
        appName:"ETPBMS"
      },
      query: (data) => ({
        url: "api/v1/document/uploadFile",
        method: "POST",
        body: data,
        headers:{
          'Authorization': 'Bearer ' + localStorage.access_token,
        }
      }),
    
    }),
  }),
});

export const {
  useGetObjectStoreFileQuery,
  useDeleteObjectStoreFileQuery,
  useSubmitObjectStoreUploadMutation,
  useDownloadObjectStoreFileQuery,
} = objectStoreApi;
